module.exports = __webpack_public_path__ + "static/media/favicon.0e43d65e.ico";